<template>
  <div id="printContent">
    <!--    <el-dialog title="维修记录" :visible.sync="printShow" :before-close="handleClose">-->
    <div id="print">
      <div class="title">{{ USER.SCHOOL.NAME }}-维修单</div>
      <table border class="table">
        <tr>
          <td>单号</td>
          <td>{{ printItem.SN }}</td>
          <td>分类</td>
          <td>{{ printItem.CAT_NAME }}</td>
        </tr>
        <tr>
          <td>描述</td>
          <td colspan="3">{{ printItem.DESCRIPTION }}</td>
        </tr>
        <tr>
          <td>照片</td>
          <td colspan="3">
            <el-image v-for="img in printItem.ImageKvs" style="width: 50px;margin-right: 10px" :key="img.Key"
              :src="img.Value" :preview-src-list="printItem.ImageKvs.map(item => item.Value)" />
          </td>
        </tr>
        <tr>
          <td>维修位置</td>
          <td colspan="3">{{ printItem.LOC_NAME }}</td>
        </tr>
        <tr>
          <td>提交人</td>
          <td colspan="3">{{ printItem.SUB_NAME }}</td>
        </tr>
        <tr>
          <td>提交时间</td>
          <td colspan="3">
            <template v-if="printItem.CREATED_DT">{{
              printItem.CREATED_DT | datetime('YYYY-MM-DD HH:mm:ss')
            }}
            </template>
          </td>
        </tr>
        <template v-if="printItem.OUTSIDERS">
          <tr>
            <td>服务单位</td>
            <td colspan="3">{{ printItem.OUTSIDERS.MEM }}</td>
          </tr>
          <tr>
            <td>维修人</td>
            <td>{{ printItem.OUTSIDERS.NAME }}</td>
            <td>联系号码</td>
            <td>{{ printItem.OUTSIDERS.MOBILE }}</td>
          </tr>
        </template>
        <tr>
          <td>状态</td>
          <td colspan="3">{{ printItem.STA_TXT }}</td>
        </tr>
        <tr>
          <td>费用</td>
          <td colspan="3">{{ printItem.COST }}</td>
        </tr>
        <tr>
          <td colspan="4">操作记录</td>
        </tr>
        <tr>
          <td>分配时间</td>
          <!-- <td colspan="3"> 维修管理 指派 {{ printItem.MENDER }} 维修</td> -->
          <td>{{ printItem.ALLOT_DT | datetime('YYYY-MM-DD HH:mm:ss') }}</td>
        </tr>
        <tr><!-- v-if="printItem.STA == 7 || printItem.STA == 8"-->
          <td>
            <!-- <template v-if="printItem.FINISH_DT">{{ printItem.FINISH_DT | datetime('YYYY-MM-DD HH:mm:ss') }}</template> -->
            维修时间
          </td>
          <td>
            <span v-if="!printItem.OUTSIDERS">{{ printItem.MENDER }}<br> </span>
            <!-- <span v-else-if="printItem.OUTSIDERS">{{ printItem.OUTSIDERS.NAME }}<br></span> -->
            {{ printItem.FINISH_DT | datetime('YYYY-MM-DD HH:mm:ss') }}
          </td>
          <td colspan="2">
            <el-image v-for="img in printItem.FinishImgKvs" style="width: 50px;margin-right: 10px" :key="img.Key"
              :src="img.Value" :preview-src-list="printItem.FinishImgKvs.map(item => item.Value)" />
          </td>
        </tr>
        <tr><!-- v-if="printItem.STA == 8"-->
          <td>验收时间</td>
          <!-- <td colspan="3">维修管理 或 {{ printItem.SUB_NAME }} 完成验收</td> -->
          <td colspan="3">{{ printItem.CHECK_DT | datetime('YYYY-MM-DD HH:mm:ss') }}</td>
        </tr>
      </table>

    </div>
    <!--      <div slot="footer">-->
    <!--        <el-button type="primary" v-print="printObj">打印</el-button>-->
    <!--        <el-button @click="handleClose">关闭</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>
<script>
export default {
  props: ['printShow', 'printItem'],
  data() {
    return {
      printObj: {
        id: 'print', // 是否打印整个页面
        popTitle: '', // 打印的标题
      },
      USER: JSON.parse(localStorage.getItem("userInfo")),
    }
  },

  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.table {
  border-collapse: collapse;
  width: 98%;
  margin: 0 auto;

  tr {
    td:nth-child(odd) {
      width: 15%;
    }

    td:nth-child(even) {
      width: 35%;
    }

    td {
      border: 1px solid #000;
    }
  }
}
</style>

<style media="print">
@media print {
  @page {
    /*size: landscape;*/
  }
}
</style>